import { render, staticRenderFns } from "./ActiveBacklog-Column.vue?vue&type=template&id=e4589a62&"
import script from "./ActiveBacklog-Column.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklog-Column.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklog-Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports